import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import Fader from '@Shared/Fader';
import React, { useEffect } from 'react';
import Article from './Article';

const Articles: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config) {
      api.getArticles(site_config.articles_path);
    }
  }, [site_config]);

  return (
    <Fader>
      {store.articles?.map((article) => {
        return (
          <Article key={article.id} article={article} />
        );
      })}
    </Fader>
  );

}

export default Articles;